import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { SERVER_URL } from '../Middlewares/app';
import axios from "axios";
import { fetchStatics, updateStatics } from '../actions/api'

function Static(props) {
    const [fileA, setFileA] = useState(null);
    const [fileB, setFileB] = useState(null);
    const [fileC, setFileC] = useState(null);
    const [checkers, setCheckers] = useState({});
        // eslint-disable-next-line
    const [mediaA, setMediaA] = useState(null);
    const [mediaB, setMediaB] = useState(null);
    const [mediaC, setMediaC] = useState(null);

    // if(statics.length()==1){
    //     setFileA(statics[0])
    // }
    const handleChange = (e, callback) => {
        callback(e.target.files[0])
    }
    // eslint-disable-next-line
    useEffect(() => {
        if (props.statics && props.statics.state && !checkers.staticsFetched) {
            setCheckers({ staticsFetched: true })
            const statics = props.statics.data || [];

            statics.forEach(element => {
                if (element.static_location === 'A')
                    setMediaA(element);
                if (element.static_location === 'B')
                    setMediaB(element);
                if (element.static_location === 'C')
                    setMediaC(element);
            });
        }

        if (props.staticsUpdated)
            window.location.reload();
        // eslint-disable-next-line
    })

    useEffect(() => {
        if (!checkers.staticsCalled) {
            setCheckers({ staticsCalled: true })
            setFileA(null);
            props.fetchStatics();
        }
        // eslint-disable-next-line
    }, [])
    const getUrl = async (file) => {
        return await axios({
            url: SERVER_URL + '/getPresignedUploadUrl',
            params: {
                contentType: file.type,
                fileName: file.name,
                v2: true,
                path: 'public/static'
            },
            method: 'GET',
            headers: { Authorization: props.user.token }
        })
    }
    const upload = (file, url) => {
        const payload = {
            url,
            method: "PUT",
            data: file,
        }
        return axios(payload)
    }
    const handleSave = async () => {
        var promises = [];
        if (fileA) {
            promises.push(new Promise(async (resolve, reject) => {
                var url = await getUrl(fileA);
                url = url.data.result
                upload(fileA, url.uploadUrl).then(() => {
                    resolve({ location: 'A', static_type: fileA.type, access_url: url.accessUrl });
                })
            }))
        }
        if (fileB) {
            promises.push(new Promise(async (resolve, reject) => {
                var url = await getUrl(fileB);
                url = url.data.result
                console.log(url);
                upload(fileB, url.uploadUrl).then(() => {
                    resolve({ location: 'B', static_type: fileB.type, access_url: url.accessUrl });
                })
            }))
        }
        if (fileC) {
            promises.push(new Promise(async (resolve, reject) => {
                var url = await getUrl(fileC);
                url = url.data.result
                upload(fileC, url.uploadUrl).then(() => {
                    resolve({ location: 'C', static_type: fileC.type, access_url: url.accessUrl });
                })
            }))
        }
        Promise.all(promises).then(res => {
            props.updateStatics({ statics: res });
        })
    }
    return <div className="container-fluid">
        <div className="row">

            {/* <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                <div className="card mt-4" style={{ width: "18rem" }}>
                    {mediaA && mediaA.static_type && mediaA.static_type.match('image/*') && <img className="card-img-top" src={mediaA.access_url} />}
                    {mediaA && mediaA.static_type && mediaA.static_type.match('video/*') && <video controls type={mediaA.static_type} className="card-img-top" src={mediaA.access_url} />}
                    <div className="card-body">
                        <p className="card-text">Location A</p>
                        <input type="file" accept="image/*, video/mp4" onChange={(e) => handleChange(e, setFileA)} />
                    </div>
                </div>
            </div> */}
            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                <div className="card mt-4" style={{ width: "18rem" }}>
                    {mediaB && mediaB.static_type && mediaB.static_type.match('image/*') && <img className="card-img-top" src={mediaB.access_url} alt="" />}
                    {mediaB && mediaB.static_type && mediaB.static_type.match('video/*') && <video controls type={mediaB.static_type} className="card-img-top" src={mediaB.access_url} />}
                    <div className="card-body">
                        <p className="card-text">Location B</p>
                        <input type="file" accept="image/*, video/mp4" onChange={(e) => handleChange(e, setFileB)} />
                    </div>
                </div>
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                <div className="card mt-4" style={{ width: "18rem" }}>
                    {mediaC && mediaC.static_type && mediaC.static_type.match('image/*') && <img className="card-img-top" src={mediaC.access_url} alt="" />}
                    {mediaC && mediaC.static_type && mediaC.static_type.match('video/*') && <video controls type={mediaC.static_type} className="card-img-top" src={mediaC.access_url} />}
                    <div className="card-body">
                        <p className="card-text">Location C</p>
                        <input type="file" accept="image/*, video/mp4" onChange={(e) => handleChange(e, setFileC)} />
                    </div>
                </div>
            </div>
        </div>
        <button className="btn btn-success btn-lg m-4" onClick={() => handleSave()}>Save</button>
    </div>

}

const mapStateToProps = ({ reducer: store }) => ({
    user: store.user,
    statics: store.statics,
    store,
    staticsUpdated: store.staticsUpdated
});

const mapDispatchToProps = {
    fetchStatics,
    updateStatics,
};

export default connect(mapStateToProps, mapDispatchToProps)(Static);

